import Menu from "../components/Menu";
import { motion, AnimatePresence } from "framer-motion";
import { Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";

export default function Offer() {
  const textVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 1.0, ease: "easeOut" },
    },
  };

  return (
    <>
      <Menu />
      <section className="section section-dark section-offer" key="sectiongray">
        <AnimatePresence>
          <motion.div
            className="h1a"
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={textVariants}
          >
            <Row key="row1">
              <Col sm={12} md={4}>
                OFERTA USŁUG
              </Col>
              <Col sm={12} md={8}>
                <p className="h4a">
                  Oferuję kompleksowe usługi wizualne dla rynku nieruchomości,
                  marketingu wnętrz oraz branży HoReCa.
                </p>
                <hr />
                <p className="h4a">1. Fotografia wnętrz i architektury</p>
                <p className="h4a">
                  ✔ zdjęcia mieszkań i domów na sprzedaż lub wynajem <br />✔
                  sesje wnętrz dla architektów i projektantów <br />✔ fotografia
                  hoteli, pensjonatów i restauracji <br />✔ zdjęcia showroomów,
                  biur i przestrzeni komercyjnych <br />✔ pełna obróbka i retusz
                  w standardzie premium <br />✔ wysyłka materiałów do 24h
                </p>
                <hr />
                <p className="h4a">
                  2. Filmy z nieruchomości (poziomo i pionowo)
                </p>
                <p className="h4a">
                  ✔ filmowe ujęcia wnętrz i architektury <br />✔ format poziomy
                  (YouTube, strony WWW) <br />✔ format pionowy (Instagram,
                  TikTok, Facebook ADS) <br />✔ dynamiczny montaż jak w
                  produkcji reklamowej
                </p>
                <hr />
                <p className="h4a">3. Dron – zdjęcia i filmy z powietrza</p>
                <p className="h4a">
                  ✔ pokaz lokalizacji, działki, otoczenia <br />✔ zgodność z
                  przepisami i ubezpieczeniem <br />✔ idealne dla deweloperów i
                  obiektów komercyjnych
                </p>
                <hr />
                <p className="h4a">4. Wirtualne spacery 360°</p>
                <p className="h4a">
                  ✔ interaktywna prezentacja nieruchomości <br />✔ obsługa na
                  stronie WWW lub jako link dla portali ogłoszeniowych <br />✔
                  idealne dla hoteli, pensjonatów i restauracji
                </p>
                <hr />
                <p className="h4a">
                  5. Staging – przygotowanie nieruchomości do zdjęć
                </p>
                <p className="h4a">
                  ✔ Staging zwykły (podstawowy) - uporządkowanie i lekkie
                  wystylizowanie przestrzeni, aby była gotowa do sesji. <br />✔
                  Staging Premium – scenografia filmowa Współpraca ze
                  scenografami i dekoratorami, pełne przygotowanie wnętrza,
                  dobór dodatków, kreacja nastroju. Wycena po obejrzeniu
                  nieruchomości i określeniu grupy docelowej. <br />✔ Staging
                  wirtualny Realizowany przez projektantów z jokuko.pl —
                  fotorealistyczna aranżacja pustych pomieszczeń, idealna przy
                  inwestycjach deweloperskich.
                </p>
                <hr />
                <p className="h4a">6. Galeria premium na moim serwerze</p>
                <p className="h4a">
                  Każdy klient otrzymuje link do galerii w pełnej jakości,
                  gotowy do wklejenia w ogłoszeniach, wysyłki SMS, WhatsApp lub
                  do udostępniania w social mediach.
                </p>
                <hr />
                <p className="h4a">7. Warunki współpracy</p>
                <p className="h4a">
                  ✔ Dojazd do 30 km od Warszawy – w cenie <br />✔ Powyżej 30 km
                  – 1 zł za kilometr <br />✔ Przy stałej współpracy — ceny
                  negocjowane indywidualnie
                </p>
                <hr />
              </Col>
            </Row>
          </motion.div>
        </AnimatePresence>
      </section>
    </>
  );
}
